
import React, { Component } from "react";

export default class BLOCK6 extends Component {
    render() {
        return (
            <div id="block-6" style={{ padding: "3px 3px 3px 3px" }}>
				<div id='menu-title' style={{backgroundImage:'url(images/RedBar.png)',color:'white'}}>
                    ข้อมูลทั่วไป
                </div>
				<div style={{textAlign:'left'}}>Audit_Title()</div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/view/block/block-6.js